import api from '../../api/client';
import React from "react";
import FarmDashboard from "../dashboard/FarmDashboard";

const SamplePage = ({ onCancel }) => {

  return (
    <React.Fragment>
      {/*  */}
      <FarmDashboard />
      {/* <ConfirmationModal show={showConfirmationModal} onHide={handleCancelConfirmation} onConfirm={handleConfirmation} /> */}
    </React.Fragment>
  );
};

export default SamplePage;
